import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, FormControl, MenuItem, Select } from "@mui/material";
import { Input, Label, Text } from "@100mslive/roomkit-react";
import FullPageProgress from "../../../FullPageProgress";
import { ToastManager } from "../../../Toast/ToastManager";
import AccountStockAddPopup from "../../Settings/AccountStockAddPopup";
import { SESSION_AUTH } from "../../../../common/auth";
import { ACCOUNT_SERVICES } from "../../../../services";

const OnBoardingOrg = props => {
  const {
    onNext,
    onBardingData,
    setOnBardingData,
    billingAddons,
    setOnBoardComplete,
  } = props;
  const { isUserSession, LOGOUT_USER_SESSION, UPDATE_USER_SESSION } =
    SESSION_AUTH();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search);
  const continueUrl = queryParameters.get("continueUrl");
  const [enableStocks, setEnableStocks] = useState(true);

  const onSave = () => {
    setEnableStocks(false);
    let parma = {
      userId: isUserSession.userId,
      org: isUserSession?.org?.id,
    };
    let name = onBardingData?.orgName?.trim();

    if (!name) {
      ToastManager.addToast({
        title: "Please enter your organization name to continue",
      });
      return false;
    }
    parma["orgName"] = name;

    parma["orgPublic"] = onBardingData?.orgPublic;

    setLoading(true);
    ACCOUNT_SERVICES.onBoardingSave(parma)
      .then(data => {
        if (data.code === 200) {
          setOnBoardComplete(true);
          if (data?.data) {
            UPDATE_USER_SESSION(data?.data);
          }
          if (!billingAddons) {
            return navigate(continueUrl || "/", { replace: true });
          } else {
            onNext(2);
          }
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else if (data.code === 201) {
          ToastManager.addToast({ title: data.message });
          return navigate("/", { replace: true });
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({
          title: err?.message,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <React.Fragment>
      {loading ? <FullPageProgress fixed={true} /> : null}
      <div className="events-page-setup-steps-body">
        <div className="events-page-setup-steps-body-label">
          NAME YOUR INVESTOR COMMUNITY
        </div>
        <div className="events-page-setup-steps-body-title mb-10">
          What is the name of your organization?
        </div>

        <div className="events-page-setup-steps-body-text">
          Your community name is the first impression investors will have of
          your hub on 6ix. Choose a name that clearly identifies your company or
          investment focus and will be discoverable across our network of
          investors, companies and experts.
        </div>

        <FormControl className="custom-form-group">
          <Label
            className="custom-form-label big-label"
            htmlFor="onboard-org-name"
          >
            Your Organization
          </Label>
          <Input
            id="onboard-org-name"
            className="custom-form-input"
            type="text"
            value={onBardingData?.orgName}
            onChange={e => {
              if (e.target?.value?.length <= 100)
                setOnBardingData(old => ({
                  ...old,
                  orgName: e.target.value
                    ?.replace(/(<([^>]+)>)/gi, "")
                    ?.replace(/\s+/g, " "),
                }));
            }}
          />
          <Text className="custom-form-label mb-0 mt-5">
            Please use 100 characters at maximum.
          </Text>
        </FormControl>
        <FormControl className="custom-form-group">
          <Label
            className="custom-form-label big-label"
            htmlFor="onboard-org-public"
          >
            Is it a public company?
          </Label>
          <Select
            id="onboard-org-public"
            name="orgPublic"
            className="custom-select"
            value={onBardingData?.orgPublic || ""}
            onChange={e => {
              setOnBardingData(old => ({
                ...old,
                orgPublic: e.target.value,
              }));
            }}
            displayEmpty
          >
            <MenuItem disabled value="">
              <span>Select</span>
            </MenuItem>
            <MenuItem value="yes">Yes</MenuItem>
            <MenuItem value="no">No</MenuItem>
          </Select>
        </FormControl>

        {onBardingData?.orgPublic === "yes" && enableStocks ? (
          <AccountStockAddPopup
            onClose={() => {
              setOnBardingData(old => ({
                ...old,
                orgPublic: "no",
              }));
            }}
            onUpdate={() => {
              onSave();
            }}
          />
        ) : null}
        <div className="text-center">
          <Button
            color="primary"
            variant="outlined"
            className="events6ix-btn events6ix-btn-primary mt-20"
            type="button"
            onClick={() => onSave()}
          >
            Continue
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default OnBoardingOrg;
